import { render, staticRenderFns } from "./_.vue?vue&type=template&id=40f43d5a&"
import script from "./_.vue?vue&type=script&lang=ts&"
export * from "./_.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports